import HttpClient from 'flow-doctor-lib/constants/HttpClient';
import { registerQuery } from 'data-fetching-client';
export const GET_BULK_ENROLLMENT_INFO = registerQuery({
  fieldName: 'bulkEnrollmentInfo',
  args: ['portalId', 'bulkProcessingId'],
  fetcher({
    portalId,
    bulkProcessingId
  }) {
    return HttpClient.get(`automation-platform-bulk-processing/v1/bulk-processing/${bulkProcessingId}`, {
      query: {
        portalId
      }
    });
  }
});